import React from "react";

export const PublicBrandingContext = React.createContext({});

export const PublicBrandingProvider = PublicBrandingContext.Provider;
